import { usePathname, useRouter } from 'expo-router'
import type React from 'react'
import { useEffect, useState } from 'react'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { useToast } from '@/src/general/components/ToastContext'
import { routeToPath } from '@/src/general/constants/routes'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

export const MailDeliveryIssueToast = (): React.ReactNode => {
  const [hasToasted, setHasToasted] = useState(false)
  const { data: me } = useMeQuery()
  const { addToast } = useToast()
  const { t } = useTranslate()
  const { routes } = useRoutes()
  const { navigate } = useRouter()
  const pathname = usePathname()

  const mailDeliveryIssues = me?.mailDeliveryIssues
  const settingsAccountPathname = routeToPath(routes.settingsAccount()).split('?')[0]

  useEffect(() => {
    if (
      (mailDeliveryIssues?.hardBounce || mailDeliveryIssues?.invalid || mailDeliveryIssues?.spamReport) &&
      pathname !== settingsAccountPathname &&
      !hasToasted
    ) {
      setHasToasted(true)
      addToast({
        message: t('user.delivery-issue-email.alert-message'),
        colors: 'danger',
        iconName: ICON.MESSAGE_INFO,
        buttons: [
          {
            children: t('words.i-check'),
            onPress: () => navigate(settingsAccountPathname),
          },
        ],
      })
    }
  }, [addToast, mailDeliveryIssues, navigate, pathname, settingsAccountPathname, t, hasToasted])

  return null
}
